import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import CountdownSection from './components/CountdownSection';
import CTABanner from './components/CTABanner';
import WhoCanParticipate from './components/WhoCanParticipate';
import WhyParticipate from './components/WhyParticipate';
import EventInfo from './components/EventInfo';
import Authority from './components/Authority';
import Testimonials from './components/Testimonials';
import SpecialGuest from './components/SpecialGuest';
import RegistrationForm from './components/RegistrationForm';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar isScrolled={isScrolled} />
      <main>
        <HeroSection />
        <CountdownSection />
        <CTABanner />
        <WhoCanParticipate />
        <WhyParticipate />
        <EventInfo />
        <Authority />
        <Testimonials />
        <SpecialGuest />
        <RegistrationForm />
      </main>
      <Footer />
    </div>
  );
}